import { render, staticRenderFns } from "./PinRegistrationHistory.vue?vue&type=template&id=2108af46&"
import script from "./PinRegistrationHistory.vue?vue&type=script&lang=js&"
export * from "./PinRegistrationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports